import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${props => props.theme.whiteLabel.spacing.sp24};
  box-sizing: border-box;
  height: 100%;
  padding: ${props => props.theme.whiteLabel.spacing.sp8} ${props => props.theme.whiteLabel.spacing.sp8}
    ${props => props.theme.whiteLabel.spacing.sp24};
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp24};
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};

  & > * {
    flex: 1;
  }
`
